/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Folder_HelpInputs */

const en_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select an export location for your video`)
};

const fr_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selectionnez un emplacement d'exportation pour votre video`)
};

const de_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie einen Exportort für Ihr Video aus.`)
};

const it_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona una posizione di esportazione per il tuo video`)
};

const ru_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите место экспорта для вашего видео.`)
};

const es_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione una ubicación de exportación para su vídeo`)
};

const zh_cn2_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择视频导出位置`)
};

const ja_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオのエクスポート先を選択してください`)
};

const hi_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने वीडियो के लिए निर्यात स्थान चुनें`)
};

const pt_pt2_video_export_folder_help = /** @type {(inputs: Video_Export_Folder_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um local para exportar seu vídeo.`)
};

/**
* | output |
* | --- |
* | "Select an export location for your video" |
*
* @param {Video_Export_Folder_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_folder_help = /** @type {((inputs?: Video_Export_Folder_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Folder_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_folder_help(inputs)
	if (locale === "de") return de_video_export_folder_help(inputs)
	if (locale === "it") return it_video_export_folder_help(inputs)
	if (locale === "ru") return ru_video_export_folder_help(inputs)
	if (locale === "es") return es_video_export_folder_help(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_folder_help(inputs)
	if (locale === "ja") return ja_video_export_folder_help(inputs)
	if (locale === "hi") return hi_video_export_folder_help(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_folder_help(inputs)
	return en_video_export_folder_help(inputs)
});